import React from "react";
import { ErrorMessage } from "../Authentication/ErrorMessage";
import { Section, Sections } from "../Common/Layout";
import { Body, Title } from "../Common/Typography";
import SelectionCardGroup from "../Inputs/SelectionCardGroup";
import { AccountTitle } from "../SideNav/__styles__/SideNav";

type SSOProvider = {
  id: string;
  name: string;
  enabled: boolean;
};

export const SSOProviderPicker = ({
  providers,
  account,
  error,
}: {
  providers: SSOProvider[];
  account: {
    id: string;
    name: string;
    logoUrl: string | null;
  };
  error?: { message: string } | null;
}) => {
  const handleProviderSelect = (providerId: string) => {
    window.location.href = `/auth/sso/initiate?accountId=${account.id}&providerId=${providerId}`;
  };

  return (
    <Sections>
      {error && <ErrorMessage error={error} />}
      <Section>
        <Title type="semiBold" size="large">
          Select your identity provider
        </Title>
        <Body size="default" type="regular" color="contentSecondary">
          Choose your organization's SSO provider to complete sign in.
        </Body>
        <SelectionCardGroup
          name="ssoProviders"
          onChange={handleProviderSelect}
          options={providers.map(provider => {
            const leftComponent = (
              <AccountTitle>{provider.name[0]}</AccountTitle>
            );
            return {
              id: provider.id,
              title: provider.name,
              value: provider.id,
              leftComponent,
              style: {
                alignItems: "center",
              },
              "data-testid": `sso-provider-${provider.id}`,
              onClick: () => handleProviderSelect(provider.id),
            };
          })}
          borderStyle="ghost"
          spacingStyle="none"
          data-orientation="vertical"
          style={{
            maxHeight: "280px",
            overflowY: "auto",
          }}
        />
      </Section>
    </Sections>
  );
};
